/**
 * The knock-out outline that lifts a reaction emoji off any background — the
 * same treatment the feed uses for its reaction stack. Shared so the dock
 * widget and the conversation view can never drift apart.
 */
export function stickerOutline(color: string): string {
  return [
    `drop-shadow(1px 0 0 ${color})`,
    `drop-shadow(-1px 0 0 ${color})`,
    `drop-shadow(0 1px 0 ${color})`,
    `drop-shadow(0 -1px 0 ${color})`,
  ].join(" ");
}
